var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9855 14.671C20.9855 17.4201 18.7491 19.6564 16 19.6564C13.2509 19.6564 11.0154 17.4201 11.0154 14.671C11.0154 11.9219 13.2509 9.68551 16 9.68551C18.7491 9.68551 20.9855 11.9227 20.9855 14.671ZM31.4563 7.59185V21.7518C31.4563 23.6395 29.9258 25.17 28.0381 25.17H3.96191C2.07421 25.17 0.543701 23.6395 0.543701 21.7518V7.59185C0.543701 5.70414 2.07421 4.17364 3.96191 4.17364H8.16632V2.99094C8.16632 1.33909 9.50455 0 11.1573 0H20.8428C22.4955 0 23.8337 1.33909 23.8337 2.99094V4.17278H28.0381C29.9258 4.17364 31.4563 5.70414 31.4563 7.59185ZM23.5491 14.671C23.5491 10.5084 20.1625 7.12185 16 7.12185C11.8383 7.12185 8.45174 10.5084 8.45174 14.671C8.45174 18.8335 11.8383 22.2201 16 22.2201C20.1625 22.2201 23.5491 18.8335 23.5491 14.671Z",
    fill: "url(#paint0_linear_2200_1348)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2200_1348",
    x1: 42.2361,
    y1: 20.5796,
    x2: 32.4346,
    y2: 35.1288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cf76fa850c7abed37c457cb8ec3f9cd8.svg";
export { ForwardRef as ReactComponent };